import { Fragment } from 'react'

const CollectionPlaceholder = () => {
    return (
        <Fragment>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
            <li className="v-placeholder">
                <span></span>
            </li>
        </Fragment>
    )
}

export default CollectionPlaceholder
